// extracted by mini-css-extract-plugin
export var buttonIconWrapper = "_7r-4";
export var collapsed = "_7r-1";
export var headerBar = "_7r-0";
export var leftHeaderContent = "_7r-3";
export var subjectContainer = "_7r-2";